<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          {{ label }}
        </div>
      </v-col>

      <v-col cols="3">
        <v-text-field
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <DateFieldCustom
          label="Дата рождения"
          :value="v.birthDate.$model"
          @change="v.birthDate.$model = $event"
          :errorMessage="v.birthDate"
          :max="new Date().toISOString()"
          :disabled="true"
        />
      </v-col>
    </v-row>

    <IdentityDocument
      :v="v.documents.identityDocument"
      :documents="identityDocuments"
      is-mrpa
    />

    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
          :disabled="true"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          v-mask="['############']"
          outlined
          :disabled="true"
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
    </v-row>

    <BaseAuthority :v="v.baseAuthority" />

    <NotaryInfo :v="v" />

    <Assistant v-if="v.assistantJob" :v="v" />
  </div>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';

import {
  EMAIL,
  getValidationErrorText,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  PERSON_NAME,
} from '@/utils/validate';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import BaseAuthority, {
  baseAuthorityModel,
  baseAuthorityValidation,
} from '@/components/services/ROD/StepApplicant/Machine/BaseAuthority';
import IdentityDocument, {
  identityDocumentModel,
  identityDocumentValidation,
} from '@/components/services/elements/IdentityDocument';
import { IdentityDocumentsRodModule } from '@/store/modules/identityDocumentsRod';
import NotaryInfo, {
  notaryInfoModel,
  notaryInfoValidation,
} from '@/components/services/elements/NotaryInfo';
import Assistant, {
  assistantValidation,
} from '@/components/services/elements/Assistant';
import deepmerge from 'deepmerge';

export const getTrusteeValidation = (trustee) => {
  let validation = {
    lastName: {
      required,
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    firstName: {
      required,
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    patronymic: {
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    birthDate: {
      required,
    },
    snils: {
      required,
    },
    inn: {
      required,
    },
    email: {
      required,
      EMAIL,
      maxLength: maxLength(MAX_LENGTH_EMAIL),
    },
    documents: {
      identityDocument: identityDocumentValidation,
    },
    baseAuthority: baseAuthorityValidation,
    ...notaryInfoValidation,
  };

  if (trustee.assistantJob) {
    validation = deepmerge(validation, assistantValidation);
  }

  return validation;
};

export const trusteeModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  birthDate: '',
  snils: '',
  inn: '',
  email: '',
  documents: {
    identityDocument: {
      type: DocumentType.IDENTIFYING,
      ...identityDocumentModel,
    },
    authorityDocument: {
      type: DocumentType.MRP,
      file: null,
      fileSig: null,
    },
  },
  baseAuthority: baseAuthorityModel,
  ...notaryInfoModel,
};

export default {
  name: 'Trustee',
  components: {
    DateFieldCustom,
    IdentityDocument,
    BaseAuthority,
    NotaryInfo,
    Assistant,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
  }),
  computed: {
    identityDocuments() {
      return IdentityDocumentsRodModule.list;
    },
  },
  async mounted() {
    if (
      !IdentityDocumentsRodModule.loading &&
      !IdentityDocumentsRodModule.loaded
    ) {
      await IdentityDocumentsRodModule.loadAll();
    }
  },
};
</script>
